import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  DeleteApiStripepaymentgatewayDeleteCardDetailMutationResponse,
  DeleteApiStripepaymentgatewayDeleteCardDetailQueryParams,
  DeleteApiStripepaymentgatewayDeleteCardDetail401,
  DeleteApiStripepaymentgatewayDeleteCardDetail403,
} from "../../../types/DeleteApiStripepaymentgatewayDeleteCardDetail";

export function getDeleteApiStripepaymentgatewayDeleteCardDetailUrl() {
  return `/api/StripePaymentGateway/delete-card-detail` as const;
}

/**
 * {@link /api/StripePaymentGateway/delete-card-detail}
 */
export async function deleteApiStripepaymentgatewayDeleteCardDetail(
  params?: DeleteApiStripepaymentgatewayDeleteCardDetailQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    DeleteApiStripepaymentgatewayDeleteCardDetailMutationResponse,
    ResponseErrorConfig<
      | DeleteApiStripepaymentgatewayDeleteCardDetail401
      | DeleteApiStripepaymentgatewayDeleteCardDetail403
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiStripepaymentgatewayDeleteCardDetailUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
